import API from "./apiService";

const Api = new API({
  baseUrl: process.env.REACT_APP_BACKEND_BASE_URL,
});

export default Api;
